var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36067 6.64636C4.95808 4.80905 9.77806 2.05086 11.5933 2.10502C13.5931 2.16477 14.6249 5.9719 13.3739 7.39964C12.6021 8.28044 8.38102 6.84326 4.62058 6.77982",
    stroke: "#101928",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40889 4.16692C6.60718 -1.17532 9.14261 2.38706 7.50649 3.67669",
    stroke: "#101928",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12267 3.43966C10.9519 2.19496 10.8101 4.88248 7.69997 5.09844",
    stroke: "#101928",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11819 5.69735C6.1124 5.67091 6.10667 5.64447 6.10073 5.61806",
    stroke: "#101928",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3711 7.50692C13.7365 7.23751 14.1715 6.97995 14.6199 6.86741C16.7217 6.34008 16.5995 9.03328 15.2245 9.9199C13.8638 10.7972 10.5228 8.97784 10.0454 10.8474",
    stroke: "#101928",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95334 17.5825H5.88062C6.1319 17.5825 6.38165 17.6125 6.62524 17.6726L8.66164 18.1692C9.10349 18.2773 9.5638 18.2878 10.0103 18.2007L12.2618 17.7611C12.8566 17.6448 13.4037 17.3589 13.8325 16.9403L15.4255 15.385C15.8805 14.9416 15.8805 14.2221 15.4255 13.7779C15.0159 13.378 14.3674 13.333 13.904 13.6721L12.0474 15.0316C11.7815 15.2267 11.458 15.3317 11.1253 15.3317H9.33249L10.4736 15.3317C11.1168 15.3317 11.6378 14.823 11.6378 14.195V13.9677C11.6378 13.4462 11.2744 12.9916 10.7564 12.8655L8.99514 12.4356C8.70851 12.3658 8.41496 12.3306 8.11988 12.3306C7.40753 12.3306 6.11807 12.9225 6.11807 12.9225L3.95334 13.8311M1 13.5163L1 17.8144C1 18.2294 1 18.4369 1.08047 18.5954C1.15126 18.7349 1.26421 18.8482 1.40314 18.9193C1.56108 19 1.76783 19 2.18134 19H2.77201C3.18551 19 3.39227 19 3.55021 18.9193C3.68913 18.8482 3.80208 18.7349 3.87287 18.5954C3.95334 18.4369 3.95334 18.2294 3.95334 17.8144V13.5163C3.95334 13.1012 3.95334 12.8937 3.87287 12.7352C3.80208 12.5958 3.68913 12.4824 3.55021 12.4113C3.39227 12.3306 3.18551 12.3306 2.77201 12.3306H2.18134C1.76783 12.3306 1.56108 12.3306 1.40314 12.4113C1.26421 12.4824 1.15126 12.5957 1.08047 12.7352C1 12.8937 1 13.1012 1 13.5163Z",
    stroke: "#101928",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateIcon);
export default __webpack_public_path__ + "static/media/donate-icon.d02f6dc812f888a75e967c3e7fe98de3.svg";
export { ForwardRef as ReactComponent };